import { EventType } from "toptaal-shared"

export type ModalType = EventType

export const modalTypeApiPrefix: Record<ModalType, string> = {
  intake: "intakes",
  lesson: "lessons",
}
